export default __webpack_public_path__ + "static/media/Group 11771.25e163ef.svg";